import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  COOKIE_CONSENT_VALUES,
  COOKIE_NO_CONTENT_ICON,
} from "@constants/cookies";
import { BlockedContentOverlayProps } from "@models/shared/shared.model";
import cookieConsentSlice from "@slices/cookieConsent.slice";
import { RootState } from "@store/index";

const BlockedContentOverlay = ({ children }: BlockedContentOverlayProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { consent } = useSelector((state: RootState) => state.cookieConsent);

  const handleOpenBanner = () => {
    dispatch(cookieConsentSlice.actions.setBannerExpanded(true));
  };

  if (consent === COOKIE_CONSENT_VALUES.ALL) {
    return <>{children}</>;
  }

  return (
    <div className="fg-blocked-content-wrapper">
      <div className="fg-blocked-content-overlay">
        <img
          className="fg-blocked-cookie-icon"
          src={COOKIE_NO_CONTENT_ICON}
          alt="Blocked Cookie Content"
        />
        <p className="fg-blocked-message">{t("cookie.blockedMessage")}</p>
        <button
          className="btn btn-primary fg-blocked-accept-btn"
          onClick={handleOpenBanner}
          type="button"
        >
          {t("cookie.manageCookies")}
        </button>
      </div>
      <div className="fg-blocked-content-children">{children}</div>
    </div>
  );
};

export default BlockedContentOverlay;
